"use client";

import { Translate } from "@/components/Translate";
import { Tag, Tags } from "@/components/ui/Tags";
import { useGlobal } from "@/features/global/GlobalContext";
import styles from "../ProductCard.module.css";

interface ProductCardTag {
	text: string;
	className?: string;
	outlined?: boolean;
	filled?: boolean;
	color?: string | number;
}

interface ProductCardTagsProps {
	tags: ProductCardTag[];
}

export const ProductCardTags = ({ tags }: ProductCardTagsProps) => {
	const { data: globalData } = useGlobal();

	if (tags.length === 0) {
		return null;
	}

	return (
		<Tags className={styles.tags}>
			{tags.map(({ text, outlined, filled, className, color }) => {
				const colorEntry = color ? globalData.colorMap[color] : undefined;
				return (
					<Tag
						key={text}
						outlined={outlined}
						filled={filled}
						className={className}
						style={
							colorEntry
								? ({
										"--tag-color": colorEntry.color,
										"--tag-foreground": colorEntry.foreground,
									} as React.CSSProperties)
								: undefined
						}
					>
						<Translate>{text}</Translate>
					</Tag>
				);
			})}
		</Tags>
	);
};
